<template>
	<b-table
			:checkable="checkable"
			:loading="isLoading"
			:paginated="true"
			:per-page="perPage"
			:striped="true"
			:hoverable="true"
			default-sort="code"
			:data='data'
			@page-change="onPageChange"
			>

		<template slot-scope="props">
			<b-table-column label="店舗名" field="shop_name" sortable>
				{{ props.row.shop_name  }}
			</b-table-column>
			<b-table-column label="タイトル" field="title" sortable>
				{{ props.row.title }}
			</b-table-column>
			<b-table-column label=" ">
				<div class="buttons is-right">
					<button class="button is-small is-warning" type="button" @click="onEditButtonClick(props.row.id)">編集</button>
					<button class="button is-small is-danger ml-10" type="button" @click="onDeleteButtonClick(props.row.id)">削除</button>
				</div>
			</b-table-column>
		</template>

		<section class="section" slot="empty">
			<div class="content has-text-grey has-text-centered">
				<template v-if="isLoading">
				</template>
				<template v-else>
					<p>データはありません</p>
				</template>
			</div>
		</section>

		<section class="page-info" slot="bottom-left">
			<div>{{ `全 ${ totalNum } 件中  ${ pageStartNum }～${ pageEndNum } 件を表示` }}</div>
		</section>
	</b-table>
</template>

<script>
	import isMobile from 'ismobilejs'
	export default {
		name: "ReportTemplate",
		props: {
			data: {
				type: Array,
				default: [],
			},
			checkable: {
				type: Boolean,
				default: false,
			},
			isLoading: {
				type: Boolean,
				default: false,
			},
			totalNum: {
				type: Number,
				default: 0,
			}
		},
		data() {
			return {
				perPage: 10,
				pageStartNum: 0,
				pageEndNum: 0,
			}
		},
		mounted() {
			if (isMobile.any) {
				this.perPage = 8;
			}
			this.displayPageInfo(1);
		},
		watch: {
			totalNum: function() {
				this.displayPageInfo(1);
			}
		},
		methods: {
			onEditButtonClick: function(id) {
				this.$router.push({ name: 'report-template-edit', params: { reportTemplateId: id }});
			},
			onDeleteButtonClick: function(id) {
				this.$emit('delete-buton-click', id);
			},
			onPageChange: function(val) {
				this.$utils.log('onPageChange');
				this.$utils.log(val);
				this.displayPageInfo(val);
			},
			displayPageInfo: function(currentPageNum = null) {
				if (this.totalNum === 0) {
					this.pageEndNum = 0;
					this.pageStartNum = 0;
				} else {
					let max = this.perPage * currentPageNum;
					this.pageStartNum = max - this.perPage + 1;
					if (max > this.totalNum) {
						this.pageEndNum = this.totalNum;
					} else {
						this.pageEndNum = this.perPage * currentPageNum;
					}
				}
			}
		},
	}
</script>

<style scoped>

</style>
